import Reveal from "@/components/Reveal";
import NewsletterForm from "@/components/NewsletterForm";
import Testimonials from "@/components/Testimonials";

// The end of the hall — a closing wall invitation. Calm, prominent, mailto only.
export default function ContactSection({ gallery }) {
  const mailto = `mailto:${gallery.artist_email}?subject=${encodeURIComponent(
    "Inquiry — " + gallery.exhibition
  )}`;

  return (
    <section className="panel panel--contact" data-testid="contact-section">
      <div className="contact__inner">
        <div className="contact__row">
          <div className="contact__main">
            <Reveal as="p" className="contact__overline mono-caps">
              {gallery.closing_title}
            </Reveal>

            <Reveal as="div" delay={0.08}>
              <a
                href={mailto}
                className="contact__cta"
                data-cursor="Write"
                data-testid="contact-artist-mailto"
              >
                Inquire about an artwork
              </a>
            </Reveal>

            <Reveal as="p" className="contact__body" delay={0.16}>
              {gallery.closing_body}
            </Reveal>

            <Reveal as="div" className="contact__details mono-caps" delay={0.24}>
              <a href={mailto} className="link-underline" data-testid="contact-email">
                {gallery.artist_email}
              </a>
              <span className="contact__dot">&middot;</span>
              <span>{gallery.location}</span>
            </Reveal>
          </div>

          <Reveal as="div" className="contact__aside" delay={0.2}>
            <Testimonials />
          </Reveal>
        </div>

        <Reveal as="div" className="contact__newsletter" delay={0.3} data-testid="newsletter-section">
          <NewsletterForm />
        </Reveal>

        <div className="contact__sign mono-caps">
          <span>{gallery.artist_name}</span>
          <span>&copy; {new Date().getFullYear()} — All works original</span>
        </div>
      </div>
    </section>
  );
}
